import { styled, Box, Typography, Switch } from '@mui/material';

export const ApplyDiscountHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '294px',
  height: '64px',
});

export const DefaultLabel = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '16px',
  color: '#555555',
});

export const StyledSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#0F52BA',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#0F52BA',
  },
});

export const DiscountContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
  boxSizing: 'border-box',
});
